import { LazyLoadImage } from "react-lazy-load-image-component";
import photo from "../../assets/photos/UNM_HS-Wellness_Art-Walk-13-0_WEB.jpg";
import "./styles.scss";

function SectionEleven({ placeholderSrc }) {
  return (
    <div className="md:tw-mt-0">
      <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[45%_55%] xl:tw-grid-cols-[10%_50%_30%]">
        <div className="tw-hidden xl:tw-block"></div>
        <div className="tw-relative">
          <LazyLoadImage
            alt="School of Medicine Corazones de Nuevo Mexico Faculty Memorial Garden"
            src={photo} // use normal <img> attributes as props
            width={"100%"}
            placeholderSrc={placeholderSrc}
            height={
              "tw-h-[360px] md:tw-h-[307px] lg:tw-h-[427px] xl:tw-h-[512px]"
            }
          />
          <div className="sectionNumber tw-absolute tw-font-extrabold xl:tw-text-[11.0rem] xl:tw-leading-[11.0rem] lg:tw-block">
            11
          </div>
        </div>
        <div className="tw-mt-4 lg:tw-mt-0 tw-flex tw-flex-col">
          <div className="tw-px-4 lg:tw-pl-[2.5rem] tw-mt-auto">
            <div className=" borderLeftMobile">
              <p className="tw-font-bold tw-italic tw-mb-0 tw-text-2xl">
                School of Medicine Corazones de Nuevo Mexico Faculty Memorial
                Garden
              </p>

              <p>
                This School of Medicine commissioned this piece to memorialize
                and “honor faculty, now deceased, whose dedication to excellence
                in teaching, discovery, and patient care allow each of us to see
                further.” Each of the engraved tubes reaching skyward is
                dedicated to a deceased colleague and convey the imagery of The
                Heart of New Mexico.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionEleven;
